<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500 text-center">Add Insurance Application</h3>
        <b-form role="form" class="mt-4" @submit.prevent="addProductApplication">
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Insurance Type">
                        <b-form-radio-group
                            required
                            v-model="form.product_type"
                            :options="productOptions"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Package">
                        <el-select v-model="form.package_name" placeholder="Select">
                            <el-option
                                v-for="(item, index) in packageOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Company">
                        <el-select v-model="form.company_name" placeholder="Select">
                            <el-option
                                v-for="(item, index) in companyOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Tenure">
											<b-form-input type="number" v-model="form.tenure" @keydown="_gHlp.checkNonNumericInput" class="w-100"></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group label="Premium p.a (RM)">
                        <CurrencyInput
                            v-model="form.premium_pa"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Premium p.m (RM)">
                        <CurrencyInput
                            v-model="form.premium_pm"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Premium Cover (RM)">
                        <CurrencyInput
                            v-model="form.premium_cover"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Paid By">
                        <el-select v-model="form.paid_by" placeholder="Select">
                            <el-option
                                v-for="(item, index) in paymentOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-button block variant="primary" class="mb-5" type="submit">Add</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, Radio, RadioGroup } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'

export default {
    props:{
        proposal: Object,
        show_insurance_application: Boolean,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        CurrencyInput,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [Radio.name]: Radio,
        [RadioGroup.name]: RadioGroup,
    },
    computed: {
        show: {
            get() {
                return this.show_insurance_application;
            },
            set(newVal) {
                this.$emit('update:show_insurance_application', newVal);
            },
        },
    },
    data() {
        return {
            form: {
                product_type: '',
                package_name: '',
                company_name: '',
								tenure: '',
                premium_pa: 0,
                premium_pm: 0,
                premium_cover: 0,
                paid_by: ''
            },
            productOptions: [
                { text: 'Investment Link', value: 'INVESTMENT_LINK' },
                { text: 'Life Insurance', value: 'LIFE_INSURANCE' }
            ],
            packageOptions: [
            {
                    value: 'Sunwira',
                    label: 'Sunwira'
                },
                {
                    value: 'Sun eSsential Life',
                    label: 'Sun eSsential Life'
                },
                {
                    value: 'Sun eSsential-i',
                    label: 'Sun eSsential-i'
                },
                {
                    value: 'Sun Legacy-i',
                    label: 'Sun Legacy-i'
                },
                {
                    value: 'Sun Prime Link-i',
                    label: 'Sun Prime Link-i'
                },
                {
                    value: 'Sun Wira',
                    label: 'Sun Wira'
                },
                {
                    value: 'Sun Heritage-i',
                    label: 'Sun Heritage-i'
                },
                {
                    value: 'Sun - Essentian-i',
                    label: 'Sun - Essentian-i'
                },
                {
                    value: 'FWD Insurance - 20 Years',
                    label: 'FWD Insurance - 20 Years',
                },
                {
                    value: 'FWD Insurance - 10 Years',
                    label: 'FWD Insurance - 10 Years',
                },
            ],
            companyOptions: [
                {
                    value: 'Sunlife',
                    label: 'Sunlife'
                },
                {
                    value: 'Manulife',
                    label: 'Manulife'
                },
                {
                    value: 'FWD Insurance BSN',
                    label: 'FWD Insurance BSN'
                },
            ],
            paymentOptions: [
                {
                    value: 'Credit Card - Auto Debit',
                    label: 'Credit Card - Auto Debit'
                },
                {
                    value: 'Transfer Bank',
                    label: 'Transfer Bank'
                },
                {
                    value: 'Cheques',
                    label: 'Cheques'
                },
                {
                    value: 'Cash',
                    label: 'Cash'
                },
                {
                    value: 'Payment Getaway',
                    label: 'Payment Getaway'
                },
                {
                    value: 'Auto debit from debit card',
                    label: 'Auto debit from debit card'
                },
            ],
        }
    },
    methods: {
        addProductApplication(){
            let data = {
                "pcom_psal_id": this.proposal.psal_id,
								"pcom_loan_statue": "INSURANCE - "+this.form.product_type,
								"pcom_final_installment":  this.form.premium_cover,
                "pcom_product_detail":{
                    "pcp_product_type":"INSURANCE",
										"pcp_project_json": {
                        "prod_ins_type": this.form.product_type,
                        "prod_ins_package":this.form.package_name,
                        "prod_ins_company":this.form.company_name,
                        "prod_ins_premium_pa":this.form.premium_pa,
                        "prod_ins_premium_pm":this.form.premium_pm,
                        "prod_ins_premium_cover":this.form.premium_cover,
                        "prod_ins_tenure":this.form.tenure,
                        "prod_ins_paid_by":this.form.paid_by,
                    }
                }
            }

            axios.post(services.initial_proposal +'ccris-item', data, {headers:getHeader()})
                .then(res=>{
                    this.notifySuccess('<b>Proposal:</b> - Successfully Added Product.')
                    this.resetForm()
                    initialProposalEventBus.$emit('refresh-proposal-detail')
                    this.$emit('update:show_insurance_application', false)
                })
                .catch(e=>{
                    this.errorFunction(e)
                })
        },
        resetForm(){
            this.form.product_type =  '',
            this.form.package_name =  '',
            this.form.company_name =  '',
            this.form.tenure =  0,
            this.form.premium_pa =  0,
            this.form.premium_pm =  0,
            this.form.premium_cover =  0,
            this.form.paid_by =  ''
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
    }
}
</script>